var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Well from "@brushfire/ui/dist/Layout/Well";
import { useEffect, useState, useContext } from "react";
import { IntlProvider } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch, useRouteMatch, useLocation, Redirect, useHistory } from "react-router-dom";
import { getEventData, getEventGroupsData, postAttendeeTypes, getQuestions, getGroup as getGroupSingle, } from "../../../data/api";
import { saveEventData, saveGroupsData } from "../../../store/Event/actions";
import { setCartData, setQuestionsData, updateCartData, updateCartStatus, updateQuestionsData, } from "../../../store/Cart/actions";
import { saveAttendeeTypeData, UpdateAttendeeTypeStatus } from "../../../store/Attendees/actions";
import RegisterFooter from "./RegisterFooter";
import Constants from "../../../data/constants";
import RegisterFrame from "./Steps/RegisterFrame";
import EventHeader from "./EventHeader";
import { UtilitiesContext, NoResults, FadeSection, usePrevious } from "@brushfire/ui";
import { LOCAL_STORAGE_KEYS, setLocal, removeLocal, getLocal, getCartId } from "../../../data/localStorageHelpers";
import { EventAccess } from "@brushfire/types";
import { handleErrors } from "../../../data/helpers";
import { getAccount } from "../../../store/Account/actions";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import InlineError from "../../UI/InlineError";
import useGroupData from "../../../hooks/useGroupData";
import EventAccessMessage from "./EventAccessMessage";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Helmet } from "react-helmet-async";
import { useResizeDetector } from "react-resize-detector";
import { WidgetContext } from "../../Widget";
import useWidgetAnalytics from "../../../hooks/useWidgetAnalytics";
import { AppFormContext, FooterVisibility } from "../../../App";
import { getAttendees, getGroup, getLookups, getOrders } from "../../../store/PostAttendeeActions/actions";
import { setGlobalLoaders, setInlineError } from "../../../store/AppState/actions";
import axios from "axios";
import { getDatabase, ref, set } from "firebase/database";
import fb from "../../../firebase";
import { useSpecificBFPayment } from "../../../hooks/useSpecificBFPayment";
import AppErrorPage from "../../../AppErrorPage";
import qs from "qs";
export var Tab;
(function (Tab) {
    Tab[Tab["DETAILS"] = 0] = "DETAILS";
    Tab[Tab["REGISTER"] = 1] = "REGISTER";
    Tab[Tab["DASHBOARD"] = 2] = "DASHBOARD";
})(Tab || (Tab = {}));
export var GroupsMode;
(function (GroupsMode) {
    GroupsMode[GroupsMode["noGroups"] = 0] = "noGroups";
    GroupsMode[GroupsMode["hide"] = 1] = "hide";
    GroupsMode[GroupsMode["buttons"] = 2] = "buttons";
    GroupsMode[GroupsMode["createGroup"] = 3] = "createGroup";
    GroupsMode[GroupsMode["joinGroup"] = 4] = "joinGroup";
})(GroupsMode || (GroupsMode = {}));
var useTypedSelector = useSelector;
export var postAttendeeRoutes = [
    Constants.Routes.myPayments,
    Constants.Routes.myGroupPayments,
    Constants.Routes.myAttendeesPayments,
    Constants.Routes.myPaymentsSummary,
    Constants.Routes.myGroupPaymentsSummary,
    Constants.Routes.myAttendeesPaymentsSummary,
    Constants.Routes.myOrderPaymentsSummary,
    Constants.Routes.myOrder,
    Constants.Routes.myOrderAttendeesShare,
    Constants.Routes.myOrderAttendeesDownload,
    Constants.Routes.myOrderAttendeesDonate,
    Constants.Routes.myOrderAttendeesPayment,
    Constants.Routes.myOrderPayments,
    Constants.Routes.myOrderAttendees,
    Constants.Routes.myOrders,
    Constants.Routes.myGroupEdit,
    Constants.Routes.myGroup,
    Constants.Routes.myGroupAttendeesShare,
    Constants.Routes.myGroupAttendeesDownload,
    Constants.Routes.myGroupAttendeesDonate,
    Constants.Routes.myGroupAttendeesPayment,
    Constants.Routes.myGroupAttendees,
    Constants.Routes.myAttendeesShare,
    Constants.Routes.myAttendeesDownload,
    Constants.Routes.myAttendeesDonate,
    Constants.Routes.myAttendeesPayment,
    Constants.Routes.myAttendees,
    Constants.Routes.myAttendee,
    Constants.Routes.myAttendeeEdit,
    Constants.Routes.myAttendeeGift,
    Constants.Routes.myAttendeeShare,
    Constants.Routes.myAttendeePayments,
    Constants.Routes.myAttendeeDonate,
    Constants.Routes.myAttendeeType,
    Constants.Routes.myAttendeeDownload,
    Constants.Routes.myAttendeeCommunity,
    Constants.Routes.myAttendeeGroup,
    Constants.Routes.myAttendeeGroupLeave,
    Constants.Routes.myAttendeeGroupCreate,
    Constants.Routes.myAttendeeCommunityLeave,
    Constants.Routes.myDashboard,
];
var buttonHiddenPaths = [
    Constants.Routes.myDashboard,
    Constants.Routes.myOrders,
    Constants.Routes.myOrderAttendeesShare,
    Constants.Routes.myOrderAttendeesDownload,
    Constants.Routes.myOrderAttendeesDonate,
    Constants.Routes.myOrderAttendeesPayment,
    Constants.Routes.myOrderAttendees,
    Constants.Routes.myOrderError,
    Constants.Routes.myAttendeesShare,
    Constants.Routes.myAttendeesDownload,
    Constants.Routes.myAttendeesDonate,
    Constants.Routes.myAttendeesPayment,
    Constants.Routes.myAttendees,
    Constants.Routes.myAttendee,
    Constants.Routes.myAttendeeError,
    Constants.Routes.myGroupAttendeesShare,
    Constants.Routes.myGroupAttendeesDownload,
    Constants.Routes.myGroupAttendeesDonate,
    Constants.Routes.myGroupAttendeesPayment,
    Constants.Routes.myGroupAttendees,
    Constants.Routes.myGroupError,
    Constants.Routes.signature,
];
var BF_QUEUE_ID = "bf-queue-id";
var Register = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
    var theme = _a.theme, path = _a.path;
    var _9 = __read(useState(), 2), registerPath = _9[0], setRegisterPath = _9[1];
    var _10 = __read(useState(true), 2), pageDataIsLoading = _10[0], setPageDataIsLoading = _10[1];
    var _11 = __read(useState(), 2), groupsMode = _11[0], setGroupsMode = _11[1];
    var _12 = __read(useState(), 2), stripeKey = _12[0], setStripeKey = _12[1];
    var _13 = __read(useState(), 2), gatewayScriptUrl = _13[0], setGatewayScriptUrl = _13[1];
    var _14 = __read(useState(null), 2), stripePromise = _14[0], setStripePromise = _14[1];
    var _15 = __read(useState(false), 2), cartTotalSeen = _15[0], setCartTotalSeen = _15[1];
    var _16 = __read(useState(), 2), sourceAttendee = _16[0], setSourceAttendee = _16[1];
    var _17 = __read(useState(false), 2), showEmailSuccess = _17[0], setShowEmailSuccess = _17[1];
    var _18 = __read(useState(false), 2), userCanManage = _18[0], setUserCanManage = _18[1];
    var _19 = __read(useState(), 2), savedTypeCode = _19[0], setSavedTypeCode = _19[1];
    var _20 = __read(useState(), 2), savedPreview = _20[0], setSavedPreview = _20[1];
    var event = useTypedSelector(function (store) { return store.events; }).event;
    var _21 = useTypedSelector(function (store) { return store.utilities; }), localization = _21.localization, utilitiesStatus = _21.utilitiesStatus, constants = _21.constants;
    var _22 = useTypedSelector(function (store) { return store.cart; }), cartStatus = _22.cartStatus, cart = _22.cart;
    var eventIsLoading = useTypedSelector(function (store) { return store.app.globalLoaders; }).eventIsLoading;
    var postAttendeeActions = useTypedSelector(function (store) { return store.postAttendeeActions; });
    var localUUID = localStorage.getItem(BF_QUEUE_ID);
    // Set payment cookie depending on path
    useSpecificBFPayment();
    var allEventLookups = (_d = (_c = (_b = postAttendeeActions.lookups) === null || _b === void 0 ? void 0 : _b.myEvents) === null || _c === void 0 ? void 0 : _c.upcoming) === null || _d === void 0 ? void 0 : _d.concat((_f = (_e = postAttendeeActions.lookups) === null || _e === void 0 ? void 0 : _e.myEvents) === null || _f === void 0 ? void 0 : _f.past);
    var dispatch = useDispatch();
    var _23 = useRouteMatch().params, eventNumber = _23.eventNumber, clientKey = _23.clientKey, urlKey = _23.urlKey, paramsLookupId = _23.lookupId;
    var history = useWidgetHistory();
    var stateHistory = useHistory();
    var location = useLocation();
    var search = location.search.toLowerCase();
    var fullPath = location.pathname
        .toLowerCase()
        .replaceAll("/", "")
        .trim();
    var searchParams = new URLSearchParams(search);
    var access = (_h = (_g = searchParams.get(path === Constants.Routes.autogroup ? "code" : "access")) !== null && _g !== void 0 ? _g : getLocal("".concat(LOCAL_STORAGE_KEYS.ACCESS))) !== null && _h !== void 0 ? _h : "";
    var typeCode = (_k = (_j = searchParams.get("typecode")) !== null && _j !== void 0 ? _j : savedTypeCode) !== null && _k !== void 0 ? _k : "";
    var rawParamGroupId = searchParams.get("group");
    var paramsGroupId = (rawParamGroupId !== null && rawParamGroupId !== void 0 ? rawParamGroupId : "") === "00000000-0000-0000-0000-000000000000" ||
        (rawParamGroupId !== null && rawParamGroupId !== void 0 ? rawParamGroupId : "").trim().toLowerCase() === "none"
        ? undefined
        : rawParamGroupId !== null && rawParamGroupId !== void 0 ? rawParamGroupId : "";
    var paramsTypeId = (_l = searchParams.get("type")) !== null && _l !== void 0 ? _l : "";
    var paramsTypeQty = parseInt((_m = searchParams.get("typeqty")) !== null && _m !== void 0 ? _m : "1");
    var promo = (_o = searchParams.get("promo")) !== null && _o !== void 0 ? _o : "";
    var all = parseInt((_p = searchParams.get("all")) !== null && _p !== void 0 ? _p : "-1");
    var preview = (_r = (_q = searchParams.get("preview")) !== null && _q !== void 0 ? _q : savedPreview) !== null && _r !== void 0 ? _r : "";
    var paramsAttendee = (_s = searchParams.get("attendee")) !== null && _s !== void 0 ? _s : "";
    var originalOrderId = (_t = searchParams.get("originalorderid")) !== null && _t !== void 0 ? _t : "";
    var localStoreGroupDataKey = "".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(eventNumber !== null && eventNumber !== void 0 ? eventNumber : "");
    var emailDirectionsIsOpen = path === Constants.Routes.emailDirections;
    var plainInfo = path === Constants.Routes.eventStart
        ? new DOMParser().parseFromString((_u = event === null || event === void 0 ? void 0 : event.eventInfo) !== null && _u !== void 0 ? _u : "", "text/html").body.textContent || ""
        : "";
    var hasEventInfoToDisplay = plainInfo.length >= 200 ||
        (event === null || event === void 0 ? void 0 : event.eventInfo.includes("img-responsive")) ||
        (event === null || event === void 0 ? void 0 : event.eventInfo.includes("video-wrapper"));
    var currentTab = postAttendeeRoutes.includes(registerPath !== null && registerPath !== void 0 ? registerPath : "") ||
        (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        (_w = (_v = stateHistory === null || stateHistory === void 0 ? void 0 : stateHistory.location) === null || _v === void 0 ? void 0 : _v.state) === null || _w === void 0 ? void 0 : _w.postAttendeeOrder)
        ? Tab.DASHBOARD
        : path === Constants.Routes.eventStart
            ? hasEventInfoToDisplay
                ? Tab.DETAILS
                : Tab.REGISTER
            : [Constants.Routes.details, Constants.Routes.emailDirections].includes(path)
                ? Tab.DETAILS
                : Tab.REGISTER;
    var _24 = useGroupData(parseInt(eventNumber)), groupId = _24.groupId, groupDataIsLoaded = _24.groupDataIsLoaded;
    var isWidget = useContext(WidgetContext).isWidget;
    var _25 = useContext(AppFormContext), formikContext = _25.formikContext, footerVisibility = _25.footerVisibility;
    var lookupId = getLocal(LOCAL_STORAGE_KEYS.LOOKUP_ID);
    var analytics = useWidgetAnalytics();
    var groupIdToUse = groupId !== null && groupId !== void 0 ? groupId : paramsGroupId;
    var previousGroupIdToUse = usePrevious(groupIdToUse);
    var _26 = useResizeDetector(), headerHeight = _26.height, headerRef = _26.ref;
    var joinGroupFromParams = function (groupData) {
        if (paramsGroupId) {
            getGroupSingle(paramsGroupId).then(function (_a) {
                var data = _a.data;
                if (data.eventNumber.toString() === eventNumber) {
                    setLocal(localStoreGroupDataKey, JSON.stringify({
                        groupId: data.id,
                        name: data.name,
                    }), 60 * 30);
                    setGroupsMode(GroupsMode.hide);
                    dispatch(updateCartStatus({
                        isLoading: false,
                        timesLoaded: cartStatus.timesLoaded + 1,
                    }));
                }
            });
        }
    };
    var assessTheme = function (props, themeData) {
        Object.keys(themeData).forEach(function (key) {
            var val = themeData[key];
            if (typeof val === "string" || typeof val === "boolean") {
                if (typeof val === "string" && val.startsWith("rgba(")) {
                    val = val
                        .split(",")
                        .splice(0, 3)
                        .join(",");
                }
                if (props[key]) {
                    if (!props[key].includes(val.toString())) {
                        props[key].push(val.toString());
                    }
                }
                else {
                    props[key] = [val.toString()];
                }
            }
            else {
                props = assessTheme(props, val);
            }
        });
        return props;
    };
    useEffect(function () {
        return function () {
            dispatch(setGlobalLoaders({ register: false }));
        };
    }, []);
    useEffect(function () {
        dispatch(getAccount(clientKey));
    }, [clientKey]);
    useEffect(function () {
        if (typeCode !== savedTypeCode) {
            setSavedTypeCode(typeCode);
        }
    }, [typeCode]);
    useEffect(function () {
        if (clientKey && eventNumber) {
            var webClient = axios.create({
                baseURL: "https://app.".concat(process.env.REACT_APP_DOMAIN, "/"),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            });
            webClient
                .get("json/usercanmanage?clientkey=".concat(clientKey, "&eventNumber=").concat(eventNumber))
                .then(function (_a) {
                var data = _a.data;
                setUserCanManage(data);
            });
        }
    }, [eventNumber]);
    useEffect(function () {
        if (eventNumber && groupDataIsLoaded) {
            dispatch(setGlobalLoaders({ eventIsLoading: true }));
            getEventData(eventNumber, typeCode, access, preview, groupIdToUse)
                .then(function (_a) {
                var _b;
                var data = _a.data;
                var eventData = data;
                if (!event) {
                    var eventGoogleAnalyticsProperties = !!eventData.googleTracking
                        ? eventData.googleTracking.toUpperCase().startsWith("UA-")
                            ? [{ number: eventData.googleTracking, domain: "" }]
                            : JSON.parse(eventData.googleTracking)
                        : [];
                    analytics.setGoogleProperties(eventGoogleAnalyticsProperties);
                    if ((_b = eventData.facebookTracking) === null || _b === void 0 ? void 0 : _b.length) {
                        analytics.setFacebookIds(eventData.facebookTracking.split("|"));
                    }
                }
                dispatch(saveEventData(eventData));
                dispatch(saveAttendeeTypeData(eventData.types));
            })
                .catch(function (err) {
                removeLocal(localStoreGroupDataKey);
                handleErrors(err, dispatch, undefined, undefined, true);
                dispatch(setGlobalLoaders({ eventIsLoading: false }));
            })
                .finally(function () {
                dispatch(setGlobalLoaders({ eventIsLoading: false }));
            });
            getEventGroupsData(eventNumber)
                .then(function (_a) {
                var data = _a.data;
                var groupData = data;
                dispatch(saveGroupsData(data));
                if (paramsGroupId) {
                    joinGroupFromParams(groupData);
                }
            })
                .catch(function (err) {
                handleErrors(err, dispatch, undefined, undefined, true);
            });
        }
    }, [eventNumber, typeCode, access, groupIdToUse]);
    useEffect(function () {
        if (groupsMode === GroupsMode.buttons &&
            ((rawParamGroupId === null || rawParamGroupId === void 0 ? void 0 : rawParamGroupId.replaceAll("-", "")) === "00000000000000000000000000000000" || rawParamGroupId === "none")) {
            removeLocal("".concat(LOCAL_STORAGE_KEYS.GROUP_ID, "-").concat(event === null || event === void 0 ? void 0 : event.eventNumber));
            setGroupsMode(GroupsMode.hide);
        }
    }, [rawParamGroupId, groupsMode]);
    useEffect(function () {
        if (promo) {
            var localPromo = getLocal(LOCAL_STORAGE_KEYS.PROMO);
            if (promo !== "" && localPromo !== promo) {
                setLocal("".concat(LOCAL_STORAGE_KEYS.PROMO), promo, 60 * 60 * 24);
            }
        }
    }, [promo]);
    useEffect(function () {
        var localAccess = getLocal(LOCAL_STORAGE_KEYS.ACCESS);
        if (access !== "" && localAccess !== access) {
            setLocal("".concat(LOCAL_STORAGE_KEYS.ACCESS), access, 60 * 60 * 24);
        }
    }, [access]);
    useEffect(function () {
        if (originalOrderId && event) {
            var lsKey = "".concat(LOCAL_STORAGE_KEYS.ORIGINAL_ORDER_ID, "-").concat(event === null || event === void 0 ? void 0 : event.eventNumber);
            var localOriginalOrderId = getLocal(lsKey);
            if (originalOrderId !== "" && localOriginalOrderId !== originalOrderId) {
                setLocal(lsKey, originalOrderId, 60 * 60);
                searchParams.delete("originalorderid");
                history.push(location.pathname, { search: qs.stringify(searchParams) });
            }
        }
    }, [originalOrderId, constants, event]);
    useEffect(function () {
        if (paramsTypeId) {
            setLocal(LOCAL_STORAGE_KEYS.ALLOW_EXPIRE, "true", 60 * 60);
        }
    }, [paramsTypeId]);
    useEffect(function () {
        if (preview !== "" && savedPreview !== preview) {
            setSavedPreview(preview);
        }
    }, [preview]);
    var continueToCart = function () {
        if (event) {
            var clientKey_1 = event.clientKey, urlKey_1 = event.urlKey, eventNumber_1 = event.eventNumber;
            var url = Constants.Routes.questions
                .replace(":clientKey", clientKey_1)
                .replace(":urlKey", urlKey_1)
                .replace(":eventNumber", eventNumber_1.toString())
                .replace(Constants.Regex.guid, "")
                .replace(":attendeeId", "");
            history.push(url);
        }
    };
    var continueToCheckout = function () {
        if (event) {
            var clientKey_2 = event.clientKey, urlKey_2 = event.urlKey, eventNumber_2 = event.eventNumber;
            var url = Constants.Routes.cart
                .replace(":clientKey", clientKey_2)
                .replace(":urlKey", urlKey_2)
                .replace(":eventNumber", eventNumber_2.toString());
            history.push(url);
        }
    };
    useEffect(function () {
        if ((event === null || event === void 0 ? void 0 : event.id) && (event === null || event === void 0 ? void 0 : event.types)) {
            var slipstreamAttendees = (((!event.hasGroupTypes && !event.isGroupCentric) || event.isGroupCentric || paramsGroupId) &&
                ((all && all > 0) || paramsTypeId !== "")) ||
                (paramsTypeId !== "" && paramsTypeQty > 0);
            if (!(!previousGroupIdToUse && groupIdToUse)) {
                dispatch(UpdateAttendeeTypeStatus({ isLoading: true }));
            }
            if (slipstreamAttendees) {
                dispatch(setGlobalLoaders({ slipstream: true }));
                var timeout = 50;
                if (promo) {
                    var localPromo = getLocal(LOCAL_STORAGE_KEYS.PROMO);
                    if (promo !== "" && localPromo !== promo) {
                        setLocal("".concat(LOCAL_STORAGE_KEYS.PROMO), promo, 60 * 60 * 24);
                    }
                    timeout = 2000;
                }
                setTimeout(function () {
                    //Add some of each to cart
                    var values = {
                        eventNumber: event.eventNumber,
                        sourceAttendeeId: null,
                        typeCode: typeCode,
                        attendees: event.types.map(function (a) {
                            var _a, _b;
                            return {
                                id: a.id,
                                quantity: all > 0 ? all : paramsTypeId === a.id ? paramsTypeQty : 0,
                                customAmount: a.allowCustomAmount ? (_a = a.allowedPayments[0]) !== null && _a !== void 0 ? _a : 0 : null,
                                amount: a.allowedPayments ? (_b = a.allowedPayments[0]) !== null && _b !== void 0 ? _b : 0 : 0,
                                selectedAmount: a.selectedAmount,
                                typeId: a.id,
                                groupId: !!paramsGroupId && paramsGroupId !== "" ? paramsGroupId : null,
                                isPreRegistered: false,
                                seatId: null,
                                sectionId: null,
                                externalDescription: "",
                                externalId: "",
                            };
                        }),
                    };
                    if (paramsTypeId && paramsTypeId !== "" && !event.types.find(function (t) { return t.id === paramsTypeId; })) {
                        values.attendees.push({
                            quantity: all > 0 ? all : paramsTypeQty,
                            amount: 0,
                            typeId: paramsTypeId,
                            groupId: !!paramsGroupId && paramsGroupId !== "" ? paramsGroupId : null,
                            isPreRegistered: false,
                            seatId: null,
                            sectionId: null,
                            externalDescription: "",
                            externalId: "",
                        });
                    }
                    postAttendeeTypes(getCartId(event.eventNumber), values)
                        .then(function (_a) {
                        var data = _a.data;
                        dispatch(updateCartStatus({
                            isLoading: false,
                            timesLoaded: cartStatus.timesLoaded + 1,
                        }));
                        var cartData = data.cart;
                        if (cartData.communityLimitExceeded) {
                            dispatch(setInlineError({ registerHeaderError: cartData.error }));
                            dispatch(setCartData(cartData));
                        }
                        else {
                            if (cartData.attendees.length) {
                                if (cartData.canContinue && cartData.attendees.every(function (a) { return a.canContinue; })) {
                                    dispatch(setCartData(cartData));
                                    continueToCheckout();
                                    dispatch(UpdateAttendeeTypeStatus({ isLoading: false }));
                                    getQuestions(cartData.cartId, cartData.eventNumber.toString()).then(function (_a) {
                                        var data = _a.data;
                                        dispatch(setQuestionsData(data));
                                    });
                                }
                                else {
                                    getQuestions(cartData.cartId, cartData.eventNumber.toString()).then(function (_a) {
                                        var data = _a.data;
                                        dispatch(setCartData(cartData));
                                        dispatch(setQuestionsData(data));
                                        continueToCart();
                                        dispatch(UpdateAttendeeTypeStatus({ isLoading: false }));
                                    });
                                }
                            }
                            else {
                                dispatch(UpdateAttendeeTypeStatus({ isLoading: false }));
                            }
                        }
                        analytics.addToCart(values, event);
                    })
                        .catch(function (err) {
                        handleErrors(err, dispatch, formikContext);
                    })
                        .finally(function () {
                        dispatch(setGlobalLoaders({ slipstream: false }));
                    });
                }, timeout);
            }
            dispatch(updateCartData(history.push));
        }
    }, [event === null || event === void 0 ? void 0 : event.id, typeCode, groupIdToUse]);
    useEffect(function () {
        if ((cart === null || cart === void 0 ? void 0 : cart.cartId) && event) {
            dispatch(updateQuestionsData(history.push));
        }
    }, [cart === null || cart === void 0 ? void 0 : cart.cartId, event === null || event === void 0 ? void 0 : event.id]);
    useEffect(function () {
        if (eventNumber) {
            setCartTotalSeen(false);
        }
    }, [eventNumber]);
    var isPostAttendeePath = postAttendeeRoutes.includes(path);
    useEffect(function () {
        if (eventNumber && lookupId && isPostAttendeePath) {
            if ((registerPath && ![Constants.Routes.lookup, Constants.Routes.myDashboard].includes(registerPath)) ||
                lookupId !== paramsLookupId ||
                !paramsLookupId) {
                var lookupData = allEventLookups === null || allEventLookups === void 0 ? void 0 : allEventLookups.find(function (evt) { var _a; return ((_a = evt === null || evt === void 0 ? void 0 : evt.event) === null || _a === void 0 ? void 0 : _a.eventNumber.toString()) === eventNumber; });
                if (!lookupData) {
                    dispatch(getLookups(lookupId, eventNumber));
                }
            }
        }
    }, [path, eventNumber, lookupId]);
    useEffect(function () {
        if ([Constants.Routes.register, Constants.Routes.tickets, Constants.Routes.details].includes(path) &&
            groupsMode === GroupsMode.buttons &&
            !(event === null || event === void 0 ? void 0 : event.isGroupCentric)) {
            setGroupsMode(GroupsMode.hide);
        }
    }, [path]);
    useEffect(function () {
        if (eventNumber && lookupId && isPostAttendeePath) {
            var lookupData = allEventLookups === null || allEventLookups === void 0 ? void 0 : allEventLookups.find(function (evt) { var _a; return ((_a = evt === null || evt === void 0 ? void 0 : evt.event) === null || _a === void 0 ? void 0 : _a.eventNumber.toString()) === eventNumber; });
            if (lookupData) {
                if (lookupData.showAttendees) {
                    dispatch(getAttendees(lookupId, eventNumber, lookupData.hasGroup, lookupData.hasOrders));
                }
                if (lookupData.hasOrders) {
                    dispatch(getOrders(lookupId, eventNumber));
                }
                if (lookupData.hasGroup) {
                    dispatch(getGroup(lookupId, eventNumber));
                }
            }
        }
    }, [(_x = postAttendeeActions.lookups) === null || _x === void 0 ? void 0 : _x.myEvents, isPostAttendeePath]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        var paymentProfile = cart && cart.paymentProfile
            ? cart.paymentProfile
            : (_b = (_a = postAttendeeActions.paymentRequiredPayload) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.paymentProfile;
        if (paymentProfile) {
            if (paymentProfile.gatewayId === Constants.Gateways.GATEWAY_STRIPE &&
                ((_c = paymentProfile.options) === null || _c === void 0 ? void 0 : _c.publishableKey) &&
                stripeKey !== ((_d = paymentProfile.options) === null || _d === void 0 ? void 0 : _d.publishableKey)) {
                var newStripePromise = loadStripe((_e = paymentProfile.options) === null || _e === void 0 ? void 0 : _e.publishableKey);
                setStripePromise(newStripePromise);
                setStripeKey((_f = paymentProfile.options) === null || _f === void 0 ? void 0 : _f.publishableKey);
            }
            else if (paymentProfile.gatewayId === Constants.Gateways.GATEWAY_SQUARE_SANDBOX) {
                setGatewayScriptUrl("https://sandbox.web.squarecdn.com/v1/square.js");
            }
            else if (paymentProfile.gatewayId === Constants.Gateways.GATEWAY_SQUARE) {
                setGatewayScriptUrl("https://web.squarecdn.com/v1/square.js");
            }
            else if (paymentProfile.gatewayId === Constants.Gateways.GATEWAY_AUTHORIZENET) {
                if (paymentProfile.options.testMode === "True") {
                    setGatewayScriptUrl("https://jstest.authorize.net/v1/Accept.js");
                }
                else {
                    setGatewayScriptUrl("https://js.authorize.net/v1/Accept.js");
                }
            }
        }
    }, [cart === null || cart === void 0 ? void 0 : cart.id, (_z = (_y = postAttendeeActions.paymentRequiredPayload) === null || _y === void 0 ? void 0 : _y.payload) === null || _z === void 0 ? void 0 : _z.paymentProfile]);
    var initialPathDataIsLoading = function (path) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var lookupData = allEventLookups === null || allEventLookups === void 0 ? void 0 : allEventLookups.find(function (e) { var _a; return ((_a = e.event) === null || _a === void 0 ? void 0 : _a.eventNumber.toString()) === eventNumber; });
        var attendeeListLoaded = ((_a = postAttendeeActions.attendees) === null || _a === void 0 ? void 0 : _a.status.loadingId) === eventNumber &&
            !((_b = postAttendeeActions.attendees) === null || _b === void 0 ? void 0 : _b.status.isLoading) &&
            ((_c = postAttendeeActions.attendees) === null || _c === void 0 ? void 0 : _c.status.isLoaded);
        var orderListLoaded = ((_d = postAttendeeActions.orders) === null || _d === void 0 ? void 0 : _d.status.loadingId) === eventNumber &&
            !((_e = postAttendeeActions.orders) === null || _e === void 0 ? void 0 : _e.status.isLoading) &&
            ((_f = postAttendeeActions.orders) === null || _f === void 0 ? void 0 : _f.status.isLoaded);
        var groupLoaded = ((_g = postAttendeeActions.groups) === null || _g === void 0 ? void 0 : _g.status.loadingId) === eventNumber &&
            !((_h = postAttendeeActions.groups) === null || _h === void 0 ? void 0 : _h.status.isLoading) &&
            ((_j = postAttendeeActions.groups) === null || _j === void 0 ? void 0 : _j.status.isLoaded);
        switch (registerPath) {
            case Constants.Routes.myDashboard:
            case Constants.Routes.myAttendee:
                if (registerPath === Constants.Routes.myDashboard && !lookupId) {
                    return true;
                }
                if (lookupData) {
                    if (lookupData.showAttendees && attendeeListLoaded) {
                        return true;
                    }
                    else {
                        return lookupData.showAttendees
                            ? attendeeListLoaded
                            : true && lookupData.hasOrders
                                ? orderListLoaded
                                : true && lookupData.hasGroup
                                    ? groupLoaded
                                    : true;
                    }
                }
                if (!allEventLookups) {
                    return false;
                }
                break;
        }
        return true;
    };
    var initialPathDataLoaded = initialPathDataIsLoading(path);
    useEffect(function () {
        if (pageDataIsLoading && initialPathDataLoaded) {
            setPageDataIsLoading(false);
        }
    }, [initialPathDataLoaded]);
    useEffect(function () {
        if (localUUID) {
            //Create subscription to allow property to determine if the user may go through
            var db = getDatabase(fb);
            var pathRef = ref(db, "/attendees/".concat(clientKey, "/").concat(localUUID, "/path"));
            set(pathRef, window.location.pathname);
        }
    }, [registerPath]);
    useEffect(function () {
        var _a;
        if (localUUID) {
            //Create subscription to allow property to determine if the user may go through
            var db = getDatabase(fb);
            var itemsRef = ref(db, "/attendees/".concat(clientKey, "/").concat(localUUID, "/i"));
            set(itemsRef, (_a = cart === null || cart === void 0 ? void 0 : cart.attendeeCount) !== null && _a !== void 0 ? _a : 0);
        }
    }, [cart === null || cart === void 0 ? void 0 : cart.attendeeCount]);
    var isLoading = eventIsLoading ||
        pageDataIsLoading ||
        utilitiesStatus.isLoading ||
        (cartStatus.isLoading && cartStatus.timesLoaded === 0);
    var hideButton = !!((_2 = (_1 = (_0 = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _0 === void 0 ? void 0 : _0.bag) === null || _1 === void 0 ? void 0 : _1.hideButton) !== null && _2 !== void 0 ? _2 : false);
    var showFooter = ((([Tab.REGISTER, Tab.DASHBOARD].includes(currentTab) && (!hideButton || !!((_3 = cart === null || cart === void 0 ? void 0 : cart.attendees) === null || _3 === void 0 ? void 0 : _3.length))) ||
        (currentTab === Tab.DETAILS && !showEmailSuccess)) &&
        !buttonHiddenPaths.includes(registerPath !== null && registerPath !== void 0 ? registerPath : "") &&
        ((_5 = (_4 = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _4 === void 0 ? void 0 : _4.bag) === null || _5 === void 0 ? void 0 : _5.hideRegisterFooter) !== true) ||
        footerVisibility === FooterVisibility.show;
    var getAssessedPath = function (path) {
        return path === Constants.Routes.eventStart
            ? hasEventInfoToDisplay
                ? Constants.Routes.details
                : Constants.Routes.register
            : path;
    };
    var showGlobalLoader = (eventIsLoading ||
        pageDataIsLoading ||
        utilitiesStatus.isLoading ||
        (path === Constants.Routes.cart && cartStatus.isLoading && cartStatus.timesLoaded === 0)) &&
        path !== Constants.Routes.lookup;
    useEffect(function () {
        dispatch(setGlobalLoaders({ register: showGlobalLoader }));
    }, [showGlobalLoader]);
    var invalidRoute = path === Constants.Routes.eventStart &&
        fullPath !==
            path
                .replace(":clientKey", clientKey)
                .replace(":urlKey", urlKey)
                .replace(":eventNumber", eventNumber)
                .replaceAll("/", "")
                .toLowerCase();
    if (invalidRoute) {
        return _jsx(AppErrorPage, { pageError: { status: 404, error: "Page not found." } });
    }
    return (_jsx("div", __assign({ className: "page-body ta-left ".concat(isWidget ? "widget" : "") }, { children: _jsx(UtilitiesContext.Provider, __assign({ value: { localization: localization } }, { children: _jsx(IntlProvider, __assign({ locale: (_6 = event === null || event === void 0 ? void 0 : event.culture) !== null && _6 !== void 0 ? _6 : "en-US" }, { children: _jsxs(Elements, __assign({ stripe: stripePromise, options: { fonts: [{ cssSrc: "https://use.typekit.net/rpz7kka.css" }] } }, { children: [_jsx(Helmet, { children: gatewayScriptUrl && _jsx("script", { type: "text/javascript", src: gatewayScriptUrl }) }), event && (_jsx("div", __assign({ ref: headerRef }, { children: _jsx(EventHeader, { event: event, currentTab: currentTab, isLoading: isLoading, isWidget: isWidget, userCanManage: userCanManage, path: registerPath !== null && registerPath !== void 0 ? registerPath : path, push: history.push, search: search }) }))), _jsxs(Well, __assign({ className: "".concat(isLoading ? "d-none" : "", " well-lg ").concat(isWidget ? "" : "border-radius-tablet-0", " ").concat(showFooter ? "register-well" : "") }, { children: [_jsx("div", { id: "register-scroll-point" }), _jsx(InlineError, { id: "registerHeaderError" }), event && !isPostAttendeePath && path !== Constants.Routes.results && (_jsx(_Fragment, { children: _jsx(EventAccessMessage, { event: event, path: registerPath !== null && registerPath !== void 0 ? registerPath : path, cart: cart }) })), sourceAttendee &&
                                    paramsAttendee &&
                                    !!event &&
                                    groupsMode !== undefined &&
                                    (path === Constants.Routes.autoreg ||
                                        [GroupsMode.buttons, GroupsMode.joinGroup, GroupsMode.createGroup].includes(groupsMode !== null && groupsMode !== void 0 ? groupsMode : GroupsMode.noGroups)) && (_jsxs("h3", __assign({ className: "m-bottom-well" }, { children: ["We've located the information for ", _jsx("b", { children: sourceAttendee.attendeeDisplay.line1 }), "! Select an option below to continue."] }))), ((event === null || event === void 0 ? void 0 : event.accessState) === EventAccess.Continue ||
                                    isPostAttendeePath ||
                                    [
                                        Constants.Routes.results,
                                        Constants.Routes.details,
                                        Constants.Routes.emailDirections,
                                    ].includes(getAssessedPath(path))) && (_jsx("div", __assign({ className: "flex-1 d-flex" }, { children: _jsxs("div", __assign({ className: "d-inline-flex flex-column w-100" }, { children: [_jsx("div", __assign({ className: "flex-1" }, { children: _jsxs(Switch, { children: [_jsx(Route, { path: __spreadArray(__spreadArray([], __read(postAttendeeRoutes), false), [
                                                                Constants.Routes.tickets,
                                                                Constants.Routes.register,
                                                                Constants.Routes.details,
                                                                Constants.Routes.section,
                                                                Constants.Routes.questions,
                                                                Constants.Routes.addons,
                                                                Constants.Routes.cart,
                                                                Constants.Routes.checkout,
                                                                Constants.Routes.results,
                                                                Constants.Routes.resetGroup,
                                                                Constants.Routes.emailDirections,
                                                                Constants.Routes.autoreg,
                                                                Constants.Routes.autogroup,
                                                                Constants.Routes.signature,
                                                                Constants.Routes.eventStart,
                                                            ], false), exact: true, render: function (props) {
                                                                var assessedPath = getAssessedPath(props.match.path);
                                                                if (assessedPath !== registerPath) {
                                                                    setRegisterPath(assessedPath);
                                                                }
                                                                return (_jsx(_Fragment, { children: _jsx(RegisterFrame, __assign({}, props, { eventData: event, theme: theme, path: assessedPath, groupsMode: groupsMode, setGroupsMode: setGroupsMode, headerHeight: headerHeight, currentTab: currentTab, setCartTotalSeen: setCartTotalSeen, cartTotalSeen: cartTotalSeen, emailDirectionsIsOpen: emailDirectionsIsOpen, showEmailSuccess: showEmailSuccess, setShowEmailSuccess: setShowEmailSuccess, typeCode: typeCode, sourceAttendee: sourceAttendee, setSourceAttendee: setSourceAttendee })) }));
                                                            } }), _jsx(Route, { exact: true, path: Constants.Routes.assignedReroute, render: function (props) {
                                                                return _jsx(Redirect, { to: "./" });
                                                            } }), _jsx(Route, { path: Constants.Routes.myOrderError, render: function (props) {
                                                                if (props.match.path !== registerPath) {
                                                                    setRegisterPath(props.match.path);
                                                                }
                                                                return (_jsx(NoResults, __assign({ icon: "search", iconWeight: "duotone" }, { children: _jsx("h4", { children: "No Order Found" }) })));
                                                            } }), _jsx(Route, { path: Constants.Routes.myAttendeeError, render: function (props) {
                                                                if (props.match.path !== registerPath) {
                                                                    setRegisterPath(props.match.path);
                                                                }
                                                                return (_jsx(NoResults, __assign({ icon: "user", iconWeight: "duotone" }, { children: _jsx("h4", { children: "No Attendee Found" }) })));
                                                            } }), _jsx(Route, { path: Constants.Routes.myGroupError, render: function (props) {
                                                                if (props.match.path !== registerPath) {
                                                                    setRegisterPath(props.match.path);
                                                                }
                                                                return (_jsx(NoResults, __assign({ icon: "search", iconWeight: "duotone" }, { children: _jsx("h4", { children: "No Group Found" }) })));
                                                            } })] }) })), _jsx(FadeSection, __assign({ fade: showFooter && ((_8 = (_7 = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _7 === void 0 ? void 0 : _7.bag) === null || _8 === void 0 ? void 0 : _8.hideFooter) !== true, className: "sticky-footer" }, { children: _jsx(RegisterFooter, { eventData: event, isLoading: isLoading, cartTotalSeen: cartTotalSeen, path: registerPath !== null && registerPath !== void 0 ? registerPath : "", hideCartBadge: registerPath === null || registerPath === void 0 ? void 0 : registerPath.includes("/my"), submitButtonLabel: emailDirectionsIsOpen
                                                        ? undefined
                                                        : currentTab === Tab.DETAILS
                                                            ? (event === null || event === void 0 ? void 0 : event.verbiage) === "Tickets"
                                                                ? "Get Tickets"
                                                                : "Register"
                                                            : undefined }) }))] })) })))] })), isWidget && !showGlobalLoader && (_jsx("div", __assign({ className: "ta-right p-top-sm p-right widget-credit", style: window.innerWidth > 767 ? {} : { backgroundColor: "white", paddingBottom: 5 } }, { children: _jsxs("small", __assign({ style: { opacity: 0.85, color: window.innerWidth > 767 ? "white" : "black" } }, { children: ["Powered by", " ", _jsx("a", __assign({ href: "https://www.brushfire.com/?utm_source=embed&utm_content=".concat(clientKey), target: "_blank", rel: "noopener noreferrer" }, { children: _jsx("img", { src: "https://www.brushfire.com/wp-content/themes/Brushfire/images/bf-mark-".concat(window.innerWidth >= 768 ? "light" : "dark", ".svg"), width: "75", alt: "Brushfire" }) })), " ", "|", " ", _jsx("a", __assign({ href: "https://brushfire.com/legal", style: { color: window.innerWidth > 767 ? "white" : "black" }, target: "_blank", rel: "noopener noreferrer" }, { children: "Legal" }))] })) })))] })) })) })) })));
};
export default Register;
